<div class="iad-page-403">
  <img src="assets/403.gif" alt="page 403" title="page 403" />
  <h1>{{ 'iadPage403.title' | translate }}</h1>
  <p>{{ 'iadPage403.title' | translate }}</p>
  <button mat-raised-button color="primary" routerLink="/agent/home">{{ 'iadPage403.homeBtnLabel' | translate }}</button>
</div>
